import fetch from '@api/fetchers';
import { HOST_TYPE } from '@utils/api-helper/host';

export const UPSC_CMS_FETCH_OPTIONS = {
  host: HOST_TYPE.CMS,
  useCamelCase: true,
  useAuthToken: false,
  skipLoader: true
};

export const fetchUpscCmsData = async (endpoint) => {
  try {
    const data = await fetch(endpoint, UPSC_CMS_FETCH_OPTIONS);

    if (!data || data.error) {
      return null;
    }

    return data;
  } catch {
    return null;
  }
};
